import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { TypeOfWithdraw } from '../../../../../core';

@JsonConverter
export class TypeOfWithdrawAdapter implements JsonCustomConvert<TypeOfWithdraw | undefined> {
    serialize(type: TypeOfWithdraw): string | undefined {
        return type ? String(type) : undefined;
    }

    deserialize(type: string): TypeOfWithdraw | undefined {
        switch (type) {
            case 'Gross':
                return TypeOfWithdraw.GROSS;
            case 'Net':
                return TypeOfWithdraw.NET;
            default:
                return undefined;
        }
    }
}
